import { render, staticRenderFns } from "./SexoSelect.vue?vue&type=template&id=546937a5"
import script from "./SexoSelect.vue?vue&type=script&lang=js"
export * from "./SexoSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports